export const EDIT_SBAT_GROUP_PAGE_TRACKINGS = {
  addSuperBatches: 'add_super_batches',
  rescheduleClass: 'reschedule_class',
};
